module.exports = __webpack_public_path__ + "fontawesome-webfont.a3de2170e4e9df77161e.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/fontawesome-webfont.ttf?v=4.5.0
// module id = ../../../../../resources/layout/fonts/fontawesome-webfont.ttf?v=4.5.0
// module chunks = styles